import React from "react";

function XVector() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="11"
            height="10"
            fill="none"
            viewBox="0 0 11 10"
        >
            <path
                fill="#B1B1B1"
                d="M.773 10L0 9.23 4.249 5 0 .77.773 0 5.02 4.23 9.27 0l.773.77L5.793 5l4.25 4.23-.773.77-4.249-4.23L.773 10z"
            ></path>
        </svg>
    );
}

export default XVector;
